import React,{useEffect,useState} from 'react';
import UserComponents from './UserComponents';
import axios from "axios";
import baseUrl from '../../../services/api';

function Users({userEmail}) {
  useEffect(() => {
   
     getUser();
   
  }, []);
  const [user, setUser] = useState([]);

  const getUser =async () => {
    var adminEmail = sessionStorage.getItem('email');
   const data =await axios
    .get(`${baseUrl}/getAllusers/${adminEmail}`)

    .then(data => {
      console.log("fghjkhgfhjkhgfhjk.....")
      console.log(data.data);
      setUser(data.data)

    
    })
    .catch(error => console.log(error));
    };

  return (
    <div className="col-span-full xl:col-span-6 shadow-lg rounded-sm " >
    <div>
    <UserComponents customers={user} userEmail={userEmail}/>
    </div>
   </div>
  );
}

export default Users;
